import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { produce } from 'immer';
import { DELETE_VALUE, SET_VALUE } from './global-variables.action-types';
var initialState = {
  sidebarOpen: false,
  processInProgress: false
};
/**
 * Global variables reducer.
 *
 * @author Mikhail Siutsou
 * @category Reducers
 * @subcategory Global variables
 * @param {GlobalVariablesState} state state.
 * @param {ActionsTypes} action action.
 * @return {GlobalVariablesState} global variables state.
 */

var globalVariablesReducer = function globalVariablesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_VALUE:
      {
        return produce(state, function (draft) {
          draft[action.payload.key] = action.payload.value;
        });
      }

    case DELETE_VALUE:
      {
        return produce(state, function (draft) {
          draft[action.payload.key] = undefined;
        });
      }

    default:
      {
        return _objectSpread({}, state);
      }
  }
};

export default globalVariablesReducer;